module.exports = __webpack_public_path__ + "static/logo-cebu-4a1b8b091537ee3e51ea1d689132d584.png";